<script lang="ts" setup>
import throttle from "lodash.throttle";

const props = defineProps({
  value: {
    type: Number,
    required: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  maxPoints: {
    type: Number,
    required: false,
  },
  allowQuickScore: {
    type: Boolean,
    required: false,
    default: false,
  },
  allowQuickMaxPoints: {
    type: Boolean,
    required: false,
    default: false,
  },
  showPointsLabel: {
    type: Boolean,
    required: false,
    default: false,
  },
  tabIndex: {
    type: Number,
    required: false,
  },
  width: {
    type: Number,
    required: false,
    default: 50,
  },
  height: {
    type: Number,
    required: false,
    default: 35,
  },
});

const emit = defineEmits(["input", "checkAllCriteria", "focus"]);

const awardFullPoints = () => {
  if (props.allowQuickMaxPoints) {
    emit("checkAllCriteria");
    return;
  }

  emit("input", props.maxPoints);
};

const awardZeroPoints = () => {
  emit("input", 0);
};

const onInput = (event: any) => {
  emit("input", event.target.value);
};

const onFocus = (ev: any) => {
  ev.target.select();
};

const inputRef = ref(null);
const { focused } = useFocus(inputRef);

const appUserDataStore = useAppUserDataStore();
const { appUser } = storeToRefs(appUserDataStore);

const onScrollScore = (ev: WheelEvent) => {
  // TODO: Add a setting to control inverte scrolling.
  let direction = ev.deltaY > 0 ? -1 : 1;
  if (appUser.value?.hasInvertedScrolling == true) {
    direction = ev.deltaY > 0 ? 1 : -1;
  }
  const newValue = (props.value ?? 0) + direction;
  emit("input", newValue);
};

const onScrollScoreThrottled = throttle(onScrollScore, 150, {
  trailing: false,
});

const onWheel = (ev: WheelEvent) => {
  if (focused.value) {
    onScrollScoreThrottled(ev);
    ev.preventDefault();
    ev.stopPropagation();
  }
};
</script>

<template>
  <div class="flex flex-row items-center">
    <span
      v-if="
        maxPoints &&
        ((disabled != true && allowQuickScore == true) ||
          allowQuickMaxPoints == true)
      "
      class="flex flex-row items-center"
    >
      <BaseIconButton
        color="success"
        @click="awardFullPoints"
        v-if="maxPoints || allowQuickMaxPoints"
      >
        <icon name="ic:baseline-check" />
      </BaseIconButton>

      <BaseIconButton
        color="danger"
        @click="awardZeroPoints"
        v-if="maxPoints && allowQuickScore"
      >
        <icon name="ic:baseline-close" />
      </BaseIconButton>
    </span>
    <input
      ref="inputRef"
      class="text-center ml-1 text-input-1 h-[40px] rounded border border-medium focus:outline-focus focus:outline-2"
      :style="{
        width: width + 'px',
        height: height + 'px',
      }"
      :disabled="disabled"
      :value="value"
      :tabIndex="tabIndex"
      @mousedown.stop.prevent="onFocus"
      @input.number="onInput"
      @wheel="onWheel"
      :class="{
        ' pointer-events-none cursor-pointer': disabled,
      }"
    />

    <span
      class="shring-0 flex flex-row justify-end"
      :class="{
        'w-[44px]': showPointsLabel != true,
      }"
    >
      <span class="mx-[4px]" v-if="maxPoints"> / </span>
      <span v-if="maxPoints"
        >{{ maxPoints }} <span v-if="showPointsLabel"> points </span>
      </span>
    </span>
  </div>
</template>

<style scoped></style>
